import { render, staticRenderFns } from "./BaseNotificationLocal.vue?vue&type=template&id=62b71b14&scoped=true&"
import script from "./BaseNotificationLocal.vue?vue&type=script&lang=js&"
export * from "./BaseNotificationLocal.vue?vue&type=script&lang=js&"
import style0 from "./BaseNotificationLocal.vue?vue&type=style&index=0&id=62b71b14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b71b14",
  null
  
)

export default component.exports